import { getCmsNewsDetail } from "../../../app/api/getCMSNews";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IApiResponse } from "../../../Orchestrator/Types/Index";
import {
  ICmsNewsResponse,
  ICMSNewsTypes,
  INewsDetailGetParams,
} from "../../../Orchestrator/Types/Interface/ICMSNews";

class GetCmsNewsDetailAction extends BaseAction<
  ICMSNewsTypes[],
  INewsDetailGetParams
> {
  override async run(): Promise<ICMSNewsTypes[] | null> {
    let listOfNews: ICMSNewsTypes[] = [];
    try {
      const { slug } = this.params!;
      const response: IApiResponse<ICmsNewsResponse> = await getCmsNewsDetail(
        slug
      );

      if (response.status === "ok" && response.answer) {
        const newsArticles = response.answer.data;
        listOfNews = newsArticles;
        updateRecoilState("newsDetailResponseAtom", listOfNews[0]);
      } else {
        updateRecoilState("newsDetailResponseAtom", null);
        console.warn("Failed to fetch News.");
      }
    } catch (error: any) {
      console.error("Error fetching News articles:", error);
    } finally {
      return listOfNews;
    }
  }
}

export const getCmsNewsDetailAction = new GetCmsNewsDetailAction();
